import { useQuery } from '@tanstack/react-query'
import { trpc } from '#app/lib/trpc-tanstack.tsx'

// User data from tRPC getCurrent query
type UserData = {
	id: string
	name: string
	email: string
	role: string
	impersonatedBy: string | null
	memberships: {
		workspace: { id: string; name: string }
		roles: { name: string }[]
	}[]
}

export function useCurrentUser() {
	return useQuery(trpc.user.getCurrent.queryOptions())
}

export function useOptionalUser() {
	const { data } = useCurrentUser()
	return data ?? undefined
}

export function useUser() {
	const maybeUser = useOptionalUser()
	if (!maybeUser) {
		throw new Error(
			'No user found, but user is required by useUser. If user is optional, try useOptionalUser instead.',
		)
	}
	return maybeUser
}

export function useSession() {
	const { data, isPending, error } = useCurrentUser()
	return { session: data, isPending, error }
}

export function useIsAdmin() {
	const user = useOptionalUser()
	return user?.role === 'admin'
}

// Alias for backward compatibility
export const useIsSuperadmin = useIsAdmin

export function useWorkspaceId() {
	const user = useOptionalUser()
	return user?.memberships[0]?.workspace.id
}
